import idea from "../../../Assets/icons/idea.png";
import intrestrate from "../../../Assets/icons/interest-rate.png";
import execution from "../../../Assets/icons/execution.png";

export const HomeCardsData = [
    {
        id: 0,
        name: "Idea Exchange",
        desc: "Share your vision with us, and we will outline a strategy to make it a digital reality.",
        icon: idea,
    },
    {
        id: 1,
        name: "Execution",
        desc: "Our team craft your project with precision, keeping you informed throughout the process",
        icon: execution,
    },
    {
        id: 2,
        name: "Launch and enhance",
        desc: "We launch your project to the world, then iterate based on real-world feedback and performance.",
        icon: intrestrate,
    },
]